var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.181 21.804.375c.25-.25.581-.375.91-.375a1.289 1.289 0 0 1 .91 2.196L13.82 12l9.804 9.804a1.286 1.286 0 0 1-1.819 1.82L12 13.822l-9.804 9.804a1.286 1.286 0 0 1-1.819-1.82l9.804-9.805L.375 2.196A1.289 1.289 0 0 1 1.285 0c.33 0 .66.125.911.375L12 10.181Z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;